import { getAllBannersForMember } from '@/api/bannersApi';
import type { Banner } from '@/state/banners/bannersTypes';

export const BANNERS_QUERY_KEY = ['banners'] as const;

export const bannersQuery = {
    queryKey: BANNERS_QUERY_KEY,
    queryFn: async (): Promise<Banner[]> => {
        const { data } = await getAllBannersForMember();
        return data ?? [];
    },
};
